(function(Drupal, $, once){
    Drupal.behaviors.or23 = {
        attach: function (settings) {

            const mobileBreakpoint = 600;
            const tabletBreakpoint = 834;
            const itemsPerPage = 7;
            const gridClass = 'grid';
            const componentClass = '.OR23';
            let galleryContainer = null;
            let images = [];
            let galleryCount = 0;
            const viewports = {
                MOBILE: 'MOBILE',
                DESKTOP: 'DESKTOP'
            };

            const $galleryContainers = $(componentClass);


            function getComponentInstance(context) {
                return $(context).closest(componentClass);
            }

            // Main entry point for script
            $(once('body', 'main')).each(function () {
                $galleryContainers.each(function () {

                    // Gallery count to track the component containers
                    galleryCount++;
                    var component = getComponentInstance(this);

                    var resizeTimer;
                    let currentSize = getViewportSize();
                    let lastSize = currentSize;

                    $(window).on('resize', function(e) {
                        clearTimeout(resizeTimer);
                        resizeTimer = setTimeout(function() {

                            currentSize = getViewportSize();
                            if (currentSize !== lastSize) {
                                initGallery(component, galleryCount);
                            }
                            lastSize = currentSize;

                        }, 250);
                    });

                    // Initialise a gallery
                    initGallery(component, galleryCount);
                    // Click handler for load more button
                    component.find('.load-more-button').on('click', function () {
                        console.log('1111 HERE FOR SOME REASON')
                        // Get the Gallery count so we can select the correct gallery container
                        var newGalleryCount = component.find(".grid").attr('data-grid-count');
                        // Use the Gallery count get the container
                        var newGalleryContainer = document.querySelector("[data-grid-count='" + newGalleryCount + "']");
                        // Figure out what the new page cursor is
                        var newCursor = parseInt(getCursor(newGalleryContainer, component)) + itemsPerPage;
                        // Update cursor, so we can refer to it next time this button is clicked
                        setCursor(newGalleryContainer, newCursor);
                        // Add the new gallery items
                        appendGalleryItems(component, newGalleryCount, newGalleryContainer, newCursor, newCursor + itemsPerPage);
                        determineLoadMoreStatus(component, newGalleryCount, newGalleryContainer);
                        // // Update the gallery library to render the new media items
                        if (getViewportSize() === viewports.DESKTOP) {
                            $(`.${gridClass}`).justifiedGallery('norewind');
                        }
                    });
                });
            });
            function initGallery(component, galleryCount) {
                // Use a multidimensional array for images as there could be many galleries on the page
                images[galleryCount] = [];
                // In order to deal with the thumbnail pagination (load more feature) we need to rebuild the image grid, using the data from the temp media list
                // Parse through each media item in the temp list and build an array of the items
                component.find('.temp-media a').each((i, element) => {
                    images[galleryCount].push({
                        type: $(element).data('media-type'),
                        src: $(element).attr('href'),
                        caption: $(element).attr('title'),
                        thumbnail: $(element).find('img').attr('src'),
                        alt: $(element).find('img').attr('alt'),
                    });
                });

                // If we have any media items in the array, we start initialising the gallery
                if (images[galleryCount].length > 0) {
                    component.find('.gallery').empty();

                    // First create the media grid container
                    createGridContainer();

                    // Add the items from the array, making sure to only show the first pages worth (e.g. 1 to 7)
                    appendGalleryItems(component, galleryCount, galleryContainer,0, itemsPerPage);

                    // Initialise the masonry and lightbox libraries
                    initGalleryLibraries();

                    // Initialise the cursor (tracks what page of items we're on)
                    setCursor(galleryContainer, 0);

                    // Figure out whether we should show the load more button or not
                    determineLoadMoreStatus(component, galleryCount, galleryContainer);
                }
            }

            function determineLoadMoreStatus(component, galleryCount, galleryContainer) {
                // If we have less media than our items per page constant, or our current page means there are no more, hide the button
                if ((images[galleryCount].length <= itemsPerPage) || ((getCursor(galleryContainer) + itemsPerPage) >= images[galleryCount].length)) {
                    component.find('.load-more-button').addClass('hide');
                } else {
                    component.find('.load-more-button').removeClass('hide');
                }
            }

            /**
             * Update page cursor data attribute
             * @param galleryContainer Gallery container
             * @param cursor New cursor value
             */
            function setCursor(galleryContainer, cursor) {
                galleryContainer.setAttribute('data-cursor', cursor);
            }

            function getViewportSize() {
                return $(window).width() >= mobileBreakpoint ? viewports.DESKTOP : viewports.MOBILE;
            }

            /**
             * Fetch current page cursor attribute from grid element
             * @returns String
             */
            function getCursor(galleryContainer) {
                return galleryContainer.getAttribute('data-cursor');
            }

            /**
             * Add media gallery items to a grid container
             * @param component - gallery component
             * @param galleryCount - gallery count
             * @param galleryContainer - gallery grid
             * @param from - start position of images array
             * @param to - end position of images array
             */
            function appendGalleryItems(component, galleryCount, galleryContainer, from, to) {
                for (let image of images[galleryCount].slice(from, to)) {
                    galleryContainer.appendChild(createGalleryItem(image));
                }
                component.find('.gallery')[0].appendChild(galleryContainer);
            }

            /**
             * Create the grid container
             */
            function createGridContainer() {
                galleryContainer = document.createElement('div');
                galleryContainer.setAttribute('class', gridClass);
                galleryContainer.setAttribute('data-grid-count', galleryCount);
            }

            /**
             * Generates the media gallery item HTML
             * @param item - Object containing gallery item data
             * @returns {HTMLDivElement}
             */
            function createGalleryItem(item) {
                const gridItemDiv = document.createElement('div');
                gridItemDiv.setAttribute('class', 'grid-item');

                const linkElement = document.createElement('a');
                linkElement.setAttribute('class', item.type);
                linkElement.setAttribute('href', item.src);
                // Title gets used for lightbox caption
                linkElement.setAttribute('title', item.caption);
                // This mfp- class is required to let the lightbox know whether to load image or iframe
                linkElement.classList.add('mfp-' + item.type);

                const imageElement = document.createElement('img');
                imageElement.setAttribute('src', item.thumbnail);
                imageElement.setAttribute('alt', item.alt);

                linkElement.appendChild(imageElement);
                gridItemDiv.appendChild(linkElement);

                return gridItemDiv;
            }

            /**
             * Initialises the Justified Gallery and Magnific Light Box
             */
            function initGalleryLibraries() {
                const $grid = $(`.${gridClass}`);
                const zoomEnabled = $(window).width() > tabletBreakpoint;
                if (getViewportSize() === viewports.DESKTOP) {
                    $grid.justifiedGallery({
                        rowHeight: 300,
                        lastRow: 'nojustify',
                        margins: 20,
                        maxRowHeight: 220,
                        captions: false
                    });
                }

                $grid.magnificPopup({
                    delegate: 'a',
                    zoom: {
                        enabled: zoomEnabled,
                        duration: 300
                    },
                    image: {
                        titleSrc: 'title',
                        verticalFit: true,
                    },
                    iframe: {
                        markup: '<div class="mfp-iframe-scaler">' +
                            '<div class="mfp-close"></div>' +
                            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                            '<div class="mfp-title">Some caption</div>' +
                            '</div>',
                        patterns: {
                            youtube: {
                                index: 'youtube.com/',
                                id: function (url) {
                                    return url;
                                },
                                src: '%id%'
                            },
                        }
                    },
                    callbacks: {
                        markupParse: function (template, values, item) {
                            values.title = item.el.attr('title');
                        }
                    },
                });

            }
        }
    }
})(Drupal, jQuery, once);
